import { AsyncPipe } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatIcon } from '@angular/material/icon';

import { I18nModule, provideConfig } from '@spartacus/core';

import { DpFeedbackBarComponent } from '@app-modules/feedback-bar/feedback-bar.component';
import { DpCustomerVoiceComponent } from '@app-shared/customer-voice/customer-voice.component';

@NgModule({
  imports: [I18nModule, AsyncPipe, MatIcon, DpCustomerVoiceComponent],
  providers: [
    provideConfig({
      cmsComponents: {
        FeedbackFABComponent: {
          component: DpFeedbackBarComponent
        }
      }
    })
  ],
  declarations: [DpFeedbackBarComponent],
  exports: [DpFeedbackBarComponent]
})
export class DpFeedbackBarModule {}
